var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.3159841 7.2355341L7.2199113.31660583c.4212258-.42214111 1.1043694-.42214111 1.5255953 0 .4213121.4222276.4213121 1.10668258 0 1.52891018L3.6831157 6.9189066h18.43814568C22.716984 6.9189066 23.2 7.4029722 23.2 7.9999892c0 .5969305-.483016 1.0810825-1.07873862 1.0810825H3.6831157l5.0622183 5.0733907c.4213121.4222276.4213121 1.1066825 0 1.5289101C8.5347642 15.8943134 8.2586071 16 7.9825363 16c-.2760707 0-.5521415-.1056866-.7627976-.3166275L.3159841 8.7644443c-.4213121-.4222276-.4213121-1.1066826 0-1.5289102z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftThin);
export default __webpack_public_path__ + "static/media/arrow-left-thin.80b74e17c065661ad518c15bfb1a98ba.svg";
export { ForwardRef as ReactComponent };